<section>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="row mb-3 mb-lg-5 mt-3 mt-lg-0">
          <div class="col-lg-4 mb-2">
            <div class="candidates-feature-info bg-success pointer-cursor" (click)="onJobStatusClicked('appliedJobs')">
              <div class="candidates-info-icon text-white">
                <i class="fas fa-thumbs-up"></i>
              </div>
              <div class="candidates-info-content">
                <h6 class="candidates-info-title text-white">Proposed Jobs</h6>
              </div>
              <div class="candidates-info-count">
                <h3 class="mb-0 text-white">{{jobStatusCounts.appliedJobs}}</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-2">
            <div class="candidates-feature-info bg-dark pointer-cursor" (click)="onJobStatusClicked('savedJobs')">
              <div class="candidates-info-icon text-white">
                <i class="fas fa-heart"></i>
              </div>
              <div class="candidates-info-content">
                <h6 class="candidates-info-title text-white">Saved Jobs</h6>
              </div>
              <div class="candidates-info-count">
                <h3 class="mb-0 text-white">{{jobStatusCounts.savedJobs}}</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-2">
            <div class="candidates-feature-info bg-danger pointer-cursor" (click)="onJobStatusClicked('jobInvites')">
              <div class="candidates-info-icon text-white">
                <i class="fas fa-envelope"></i>
              </div>
              <div class="candidates-info-content">
                <h6 class="candidates-info-title text-white">Job Invites</h6>
              </div>
              <div class="candidates-info-count">
                <h3 class="mb-0 text-white">{{jobStatusCounts.invitedJobs}}</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-2">
            <div class="candidates-feature-info bg-danger pointer-cursor" (click)="onJobStatusClicked('inProgressJobs')">
              <div class="candidates-info-icon text-white">
                <i class="fas fa-spinner"></i>
              </div>
              <div class="candidates-info-content">
                <h6 class="candidates-info-title text-white">In Progress Jobs</h6>
              </div>
              <div class="candidates-info-count">
                <h3 class="mb-0 text-white">{{jobStatusCounts.inProgressJobs}}</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-2">
            <div class="candidates-feature-info bg-danger pointer-cursor" (click)="onJobStatusClicked('finishedJobs')">
              <div class="candidates-info-icon text-white">
                <i class="fas fa-check"></i>
              </div>
              <div class="candidates-info-content">
                <h6 class="candidates-info-title text-white">Finished Jobs</h6>
              </div>
              <div class="candidates-info-count">
                <h3 class="mb-0 text-white">{{jobStatusCounts.finishedJobs}}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="user-dashboard-info-box mb-0 pb-4">
          <list-jobs [title]="title" [jobs]="jobs" [totalPageCount]="pageCount"
            (pageNumberClicked)="pageNumberClicked($event)"></list-jobs>
        </div>
      </div>
    </div>
  </div>
</section>
